import axios from "axios";
import jwt_decode from "jwt-decode";
import { userLogout } from "../features/actions/authAsyncAction";
import { toast } from "react-toastify";

// PRODUCTION
const PRODUCTION_URL = "https://netfee.top/api/v1/";

// DEVELOPMENT
// const DEV_URL = "https://netfee.top/api/v1/";
const DEV_URL = "http://localhost:9099/api/v1/";

export const BASE_URL =
  process.env.NODE_ENV === "production" ? PRODUCTION_URL : DEV_URL;

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

const apiLink = axios.create({
  baseURL: BASE_URL,
});

apiLink.interceptors.request.use(
  async (config) => {
    const TOKEN = await JSON.parse(localStorage.getItem("netFeeToken"));

    if (!TOKEN) {
      userLogout();
      localStorage.removeItem("netFeeToken");
    }

    let currentDate = new Date();
    const decodedToken = jwt_decode(TOKEN);

    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      userLogout();
    } else {
      config.headers["authorization"] = "Bearer " + TOKEN;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiLink.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response?.status === 400 || error.response?.status === 404) {
    //   toast.error(error.response?.data?.message);
    // }

    if (error.response?.status === 401) {
      toast.error(error.response?.data?.message);
      setTimeout(() => {
        userLogout();
      }, 500);
    }

    return Promise.reject((error.response && error.response?.data) || error);
  },
);

export default apiLink;
